import {
  CreateDictionaryURL, UpdateDictionaryURL, ListDictionaryURL, DeleteDictionaryURL,
  ListDictionaryValueURL, CreateDictionaryValueURL, UpdateDictionaryValueURL, DeleteDictionaryValueURL
} from '@/consts/consts'
import {POST} from "@/utils/request/request";

export function CreateDictionary(data) {
  return POST(CreateDictionaryURL, data)
}

export function DeleteDictionary(data) {
  return POST(DeleteDictionaryURL, data)
}

export function UpdateDictionary(data) {
  return POST(UpdateDictionaryURL, data)
}

export function ListDictionary(data) {
  return POST(ListDictionaryURL, data)
}

export function ListDictionaryValue(data) {
    return POST(ListDictionaryValueURL, data)
  }

export function CreateDictionaryValue(data) {
    return POST(CreateDictionaryValueURL, data)
}

export function UpdateDictionaryValue(data) {
    return POST(UpdateDictionaryValueURL, data)
}

export function DeleteDictionaryValue(data) {
  return POST(DeleteDictionaryValueURL, data)
}
